// let api = "http://192.168.1.33:7788"
// let pocapi = "http://arkpocapi-t.obj1.cn"
// let pocApiPoor = "http://arkapi-t.obj1.cn"  //测试
let pocApiPoor = "http://sgzapi.ymkjc.com"  
let pocapi = "http://iaapi.obj1.cn"  //正式
// let suyuanApi="http://guiruisuyuan.obj1.cn"
let params = 'EntCode=SGZ'
import axios from 'axios'
export default {
    getQueryHistoryScanCode() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/Statistics/QueryHistoryScanCode?' + params).then(res => {
                let data = res.data.data
                data.value = data.count,
                    delete data.count
                data.unit = ''
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // getQueryHistoryScanCode() {
    //     return $axios.Get('/api/Statistics/QueryHistoryScanCode', params).then(res => {
    //         let data = res.data
    //         data.value = data.count,
    //             delete data.count
    //         data.unit = ''
    //         return data
    //     })
    // },

    getQueryScanCodeHeatMap() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/Statistics/GetOutStockList?' + params).then(res => {
                let data = res.data.data
                data.forEach(item => {
                    
                    item.city=  item.city.split('市')[0]
                    item.name = item.city
                    item.value = {}
                    item.value = { '销售量': item.outStockNumber }
                    delete item.city
                    delete item.outStockNumber
                });
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getQueryProductScanCode() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/Statistics/QueryProductScanCode?' + params).then(res => {

                let data = res.data.data

                let obj = {}
                obj = {
                    allRank: [],
                    tenRank: [],
                    img1: [],
                    img2: []
                }
                data.forEach((item, index) => {
                    if (index < 12) {
                        obj.allRank.push({ name: item.productName, value: item.count })
                    }

                    if (index < 5) {
                        obj.tenRank.push({ name: item.productName, value: item.count })
                            // obj.tenRank.push({ name: '一公牛特技一', value: item.count })
                    }
                    if (index < 6) {
                        obj.img1.push(item.picUrl)
                    }

                })
                resolve(obj)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getQueryTotalCode() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/Statistics/QueryTotalCode?' + params).then(res => {

                let data = res.data.data + ''
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getQueryMonthScanCode() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/Statistics/QueryMonthScanCode?' + params).then(res => {
                let data = res.data.data

                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getQueryTop20ScanCode() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/Statistics/QueryTop20ScanCode?' + params).then(res => {
                let data = res.data.data
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getQueryLastWealther() {
        return new Promise((resolve, reject) => {
            axios.get(pocapi+'/api/Statistics/QueryWealther?' + params).then(res => {
                let data = res.data.data
                let obj = { light: [], airPressure: [], temperature: [], humidity: [], rainarr: [], lastWeather: {} }
                data.light.data = data.light.value
                obj.light.push(data.light)
                data.airPressure.data = data.airPressure.value
                obj.airPressure.push(data.airPressure)
                data.humidity.data = data.humidity.value
                data.temperature.data = data.temperature.value
                obj.temperature.push(data.soilTemperature)
                obj.temperature.push(data.temperature)
                data.soilHumidity.data = data.soilHumidity.value
                data.soilTemperature.data = data.soilTemperature.value
                obj.humidity.push(data.soilHumidity)
                obj.humidity.push(data.humidity)
                let hourRainfall = data.hourRainfall.value || []
                let rainarr = []
                let n = 0
                hourRainfall.forEach(item => {
                    let obj = {}
                    obj.name = n
                    obj.value = item
                    rainarr.push(obj)
                    n = n + 2
                })
                obj.rainarr = rainarr
                obj.lastWeather = data.lastWeather.value
                resolve(obj)
            }).catch(err => {
                reject(err)
            })
        })
    },
    getPovrety() {
        return new Promise((resolve, reject) => {
            axios.get(pocApiPoor+'/api/BaseInfo/GetHelpPoorList?' + params).then(res => {
                let data = res.data.data
                data.totalHelpMan.value = data.totalHelpMan.value + ''
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}